import * as React from 'react';
import styled from '@emotion/styled';
import { observer } from 'src/utils/mobx-react';

interface PropsType {
    className?: string;
    onClick?: () => void;
}

const SvgElement = styled('svg', { label: 'SvgElement' })`
    height: auto;
`;

export const GaelicHurlingIcon = observer('GaelicHurlingIcon', ({ className, onClick }: PropsType): JSX.Element => {
    return (
        <SvgElement
            xmlns='http://www.w3.org/2000/svg'
            width='24'
            height='24'
            viewBox='0 0 24 24'
            fill='#061A32'
            className={className}
            onClick={onClick}
        >
            <path
                d='M21.2512 7.72046C21.0602 7.91144 20.8588 8.04898 20.6528 8.12874C19.9952 8.38355 19.2051 8.73761 18.4494 9.14003L15.8607 6.55132C16.1594 5.94202 16.2208 5.16066 15.9253 4.4557C15.6571 3.81355 15.7728 3.25519 16.2794 2.74859C17.4216 1.6064 19.4661 1.79218 20.837 3.16292C22.2077 4.5337 22.3935 6.5782 21.2512 7.72046Z'
                fill='fill'
            />
            <path
                d='M2.74847 7.7205C2.93945 7.91148 3.14093 8.04901 3.34687 8.12878C4.00457 8.38355 4.79457 8.73761 5.55023 9.14011L8.13894 6.5514C7.84027 5.94206 7.77886 5.16073 8.07433 4.45577C8.34254 3.81362 8.22683 3.2553 7.72027 2.74866C6.57808 1.6064 4.53363 1.79218 3.16277 3.16296C1.79195 4.53374 1.60621 6.57823 2.74847 7.7205Z'
                fill='fill'
            />
            <path
                d='M8.86838 7.47916L9.6719 8.33287L7.53065 10.4742C7.22733 10.2162 6.91483 9.97295 6.59002 9.75752L8.86838 7.47916Z'
                fill='fill'
            />
            <path
                d='M9.65606 19.6562C9.65606 18.3636 10.7072 17.3125 11.9998 17.3125C13.2924 17.3125 14.3436 18.3636 14.3436 19.6562C14.3436 20.9489 13.2924 22 11.9998 22C10.7072 22 9.65606 20.9489 9.65606 19.6562Z'
                fill='fill'
            />
            <path
                d='M16.768 15.8727L10.4754 9.18669L8.40887 11.2532L15.1979 17.4428L16.768 15.8727Z'
                fill='fill'
            />
            <path
                d='M21.8282 20.8343L20.8341 21.8284C20.612 22.0505 20.2543 22.0579 20.023 21.8452L16.0649 18.2331L17.5715 16.7265L20.8246 20.1806L20.9996 20.0057C21.2284 19.7769 21.5993 19.7768 21.8282 20.0057C22.057 20.2345 22.057 20.6055 21.8282 20.8343Z'
                fill='fill'
            />
            <path
                d='M14.7505 12.0193L12.8043 9.95158L13.5242 9.18661L15.5908 11.2532L14.7505 12.0193Z'
                fill='fill'
            />
            <path
                d='M17.4097 9.75752L15.1313 7.47916L14.3278 8.33287L16.4691 10.4742C16.7724 10.2162 17.0849 9.97298 17.4097 9.75752Z'
                fill='fill'
            />
            <path
                d='M11.1301 15.32L9.31186 13.6624L7.23162 15.8727L8.8017 17.4428L11.1301 15.32Z'
                fill='fill'
            />
            <path
                d='M3.97659 21.8452C3.74534 22.0579 3.38757 22.0505 3.1655 21.8284L2.17143 20.8343C1.94261 20.6055 1.94261 20.2345 2.17143 20.0057C2.40034 19.7768 2.77124 19.7769 3.00007 20.0057L3.17503 20.1806L6.42815 16.7265L7.93475 18.2331L3.97659 21.8452Z'
                fill='fill'
            />
        </SvgElement>
    );
});
